import { render, staticRenderFns } from "./DrawerSettings.vue?vue&type=template&id=16b7872a&scoped=true&"
import script from "./DrawerSettings.vue?vue&type=script&lang=js&"
export * from "./DrawerSettings.vue?vue&type=script&lang=js&"
import style0 from "./DrawerSettings.vue?vue&type=style&index=0&id=16b7872a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b7872a",
  null
  
)

export default component.exports